export default {
      id: "good-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#good",
      toString: function () {
        return this.url;
      }
    }